import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { ROLE_PERMISSIONS } from '@app/core/constants/admin-roles';
import { UserRole } from '@app/core/models/enums';

interface RequiredPermission {
  feature: keyof (typeof ROLE_PERMISSIONS)[UserRole.SUPER_ADMIN];
  action: string;
}

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const requiredPermission = route.data?.['requiredPermission'] as RequiredPermission | undefined;

  if (!requiredPermission) {
    return true;
  }

  const role = authService.getUserRole();

  if (!role) {
    return router.createUrlTree(['/auth/login']);
  }

  const permissions = ROLE_PERMISSIONS[role as keyof typeof ROLE_PERMISSIONS];

  if (!permissions) {
    return router.createUrlTree(['/dashboard']);
  }

  const featurePermissions = permissions[requiredPermission.feature];

  if (!featurePermissions) {
    return router.createUrlTree(['/dashboard']);
  }

  const hasPermission = (featurePermissions as readonly string[]).includes(requiredPermission.action);

  if (hasPermission) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
